<div class="main-content">
	<div class="container-fluid">
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header card-header-{{color}}">
						<h4 class="card-title">Vendor payment remittance email</h4>
						<p class="card-category mb-0">Preview the message vendors receive. Enable to send automatically to the supplier <strong>Email</strong> field when a payment is posted.</p>
					</div>
					<div class="card-body">
						<div *ngIf="loading" class="text-center py-5">
							<mat-spinner diameter="40"></mat-spinner>
						</div>
						<div *ngIf="!loading && loadError" class="alert alert-warning">{{ loadError }}</div>
						<div *ngIf="!loading && !loadError" class="remit-controls mb-4">
							<mat-slide-toggle [checked]="enabled" (change)="onToggle($event.checked)">Send remittance email when vendor payments are posted</mat-slide-toggle>
							<button mat-raised-button color="primary" class="ml-3" (click)="save()" [disabled]="saving">
								<span *ngIf="!saving">Save</span>
								<span *ngIf="saving">Saving…</span>
							</button>
						</div>
						<div *ngIf="!loading && trustedPreview" class="preview-wrap">
							<h5 class="mb-2">Email preview</h5>
							<iframe class="remit-preview-frame" title="Remittance email preview" [srcdoc]="trustedPreview" sandbox=""></iframe>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
